export const swiperBreakpoints = {
  '3840': {
    slidesPerView: 13.2
  },
  '3776': {
    slidesPerView: 13
  },
  '3544': {
    slidesPerView: 12
  },
  '3312': {
    slidesPerView: 11
  },
  '3080': {
    slidesPerView: 10
  },
  '2848': {
    slidesPerView: 9
  },
  '2616': {
    slidesPerView: 8
  },
  '2384': {
    slidesPerView: 7
  },
  '2152': {
    slidesPerView: 6
  },
  '1920': {
    slidesPerView: 6
  },
  '1600': {
    slidesPerView: 5
  },
  '1400': {
    slidesPerView: 4
  },
  '1200': {
    slidesPerView: 4
  },
  '992': {
    slidesPerView: 3.5
  },
  '768': {
    slidesPerView: 2.5
  },
  '664': {
    slidesPerView: 2.5
  },
  '580': {
    slidesPerView: 2.2
  },
  '410': {
    slidesPerView: 1.5
  }
};
